module.exports = __webpack_public_path__ + "media/images/admin/node_builder_img/icons/startnode-f1becc0cfdee38ace0cc3fa14f4822da.svg";